<template>
  <div>
    <DashboardHeader title="Manage Users">
      <v-row>
        <v-col :cols="isMobile ? 12 : 3" class="mx-5 mt-4">
          <vAlertHeader
            :color="getThemeColor"
            title="Select User To Manage"
          ></vAlertHeader>
          <v-card v-if="isManager" class="mt-n4" elevation="12" outlined>
            <v-card-title class="ml-8 my-0">1. Select User Below</v-card-title>
            <v-list-item class="mt-n2">
              <v-autocomplete
                prepend-inner-icon="search"
                v-model="selectedUserId"
                item-text="email"
                item-value="id"
                :items="users"
                solo-inverted
                flat
                hide-details
                label="Search User"
                @change="getSelectedUser()"
              ></v-autocomplete>
            </v-list-item>
            <v-row>
              <v-card-title class="ml-8 my-0">OR</v-card-title>
            </v-row>
            <v-text-field
              solo-inverted
              prepend-inner-icon="search"
              v-model="searchUserEmail"
              class="mx-4"
              label="Search Entire Database"
            ></v-text-field>
            <v-btn
              class="ml-4 mb-4"
              :color="getThemeColor"
              dark
              rounded
              @click="searchUserFromEntireDatabase()"
              >Search Database</v-btn
            >
          </v-card>

          <v-card
            class="mt-4"
            shaped
            elevation="12"
            outlined
            v-if="selectedUser != null && isManager"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <v-row class="overline mb-4">
                  <span class="mx-4">User Profile</span>
                </v-row>

                <v-list-item-title class="headline mb-1">{{
                  selectedUser.name
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >Access Level: {{ selectedUser.alevel }}</v-list-item-subtitle
                >
              </v-list-item-content>

              <v-list-item-avatar tile size="80" :color="getThemeColor">
                <v-img
                  size="80"
                  scr="https://static.vecteezy.com/system/resources/previews/000/620/163/non_2x/circle-logo-and-symbols-vector.jpg"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list two-line>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{
                    selectedUser.phone_number
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Contact Number</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-icon>mdi-message-text</v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-email</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{
                    selectedUser.email
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Main</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-account-key</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{
                    selectedUser.employee_id
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-select
                      class="mx-3"
                      :items="alevels"
                      :label="
                        'Access Level: ' +
                        selectedUser.alevel +
                        ' [' +
                        selectedUser.role +
                        ']'
                      "
                      v-model="selectedAlevel"
                      @change="grantAccessLevel()"
                    ></v-select>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-card-actions
              >Last Seen: {{ selectedUser.last_seen }}</v-card-actions
            >
          </v-card>
        </v-col>
        <v-col :cols="isMobile ? 12 : 8" class="mx-5 mt-4">
          <v-card>
            <v-row>
              <v-spacer></v-spacer>
              <v-select
                :items="statuses"
                class="mx-14"
                v-model="status"
                label="Manage Users"
                @change="getSelectedValue()"
                v-if="isManager"
              ></v-select>
            </v-row>

            <v-card-title>
              {{ tableTitle }}
              <v-btn
                class="mx-6"
                rounded
                :color="getThemeColor"
                dark
                small
                @click="openDailogInvite()"
                >Invite Users</v-btn
              >
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-data-table
              :headers="headersAc"
              :items="usersAc"
              :search="search"
            >
              <template v-slot:item.action="{ item }">
                <v-chip
                  v-if="item.banned_at"
                  class="ma-2"
                  small
                  color="orange"
                  dark
                  @click="unbanUser(item)"
                >
                  <v-icon left>mdi-account-check</v-icon>Unban
                </v-chip>

                <div v-else>
                  <v-textarea
                    v-if="isManager"
                    :ref="'user_' + item.id"
                    clearable
                    rows="1"
                    clear-icon="cancel"
                    label="Reason"
                  ></v-textarea>
                  <v-chip
                    class="ma-2"
                    v-if="isManager"
                    small
                    color="red"
                    dark
                    @click="banUser(item)"
                  >
                    <v-icon left>mdi-account-remove</v-icon>Ban
                  </v-chip>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <div class="text-center">
          <GlobalDialogSlot
            title="Invite User"
            :dialog="dialog"
            @close-dialog="closeDialog()"
          >
            <v-card v-if="selectedUser && !inviteUser">
              <v-card-title :style="getThemeStyle" class="headline lighten-2"
                >Linking Student to: {{ selectedUser.name }}</v-card-title
              >

              <v-autocomplete
                class="mx-3"
                :items="students"
                prepend-icon="mdi-magnify"
                label="Search Student"
                v-model="selectedStudent"
              ></v-autocomplete>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <vButton
                  :color="getThemeColor"
                  @button-clicked="linkParentToStudent"
                  icon="mdi-link"
                >
                </vButton>
              </v-card-actions>
            </v-card>
            <InviteUser v-if="inviteUser" @close-dialog="closeDialog()">
            </InviteUser>
          </GlobalDialogSlot>
        </div>
      </v-row>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
import vButton from "@/components/Legos/vButton.vue";
import InviteUser from "./InviteUser.vue";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios.getData("/auth/get-all-users", this.getAccessToken).then((users) => {
      this.users = users;

      axios
        .getData("/auth/get-users-access-links", this.getAccessToken)
        .then((usersAc) => {
          this.usersAc = usersAc;
          this.$store.commit("setLoader", false);
        });
    });
  },
  components: {
    DashboardHeader,
    GlobalDialogSlot,
    vButton,
    InviteUser,
    vAlertHeader,
  },
  data: () => ({
    searchUserEmail: null,
    alevels: [
      { text: "Everybody [1]", value: 1 },
      { text: "Staff [5]", value: 5 },
      { text: "Admin [7]", value: 7 },
      { text: "Manager [9]", value: 9 },
      { text: "Super Admin [11]", value: 11 },
    ],
    dialog: false,
    invitationForm: null,
    inviteUser: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    snackbarModel: false,
    snackbarModel2: false,
    snackbarModel3: false,
    students: [],
    valid: false,
    selectedUserId: "",
    selectedUser: null,
    selectedUserId2: "",
    selectedAlevel: "",
    selectedAlevel2: "",
    selectedStudent: "",
    userEmail: null,
    userName: null,
    userAccess: null,
    userPhone: null,
    userSid: null,
    nameRules: [(v) => !!v || "Field is required"],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    text: "Hello,  a snackbar",
    status: null,
    tableTitle: "All Users Accounts",
    statuses: [
      { text: "All User Accounts", value: "all" },
      { text: "Active User Accounts", value: "unban" },
      { text: "Deactivated User Accounts", value: "ban" },
    ],
    search: "",
    headers: [
      {
        text: "Full Names",
        align: "start",
        value: "name",
      },
      { text: "Email", value: "email" },
      { text: "Access Level", value: "alevel" },
      { text: "Actions", value: "actions" },
    ],
    headersAc: [
      {
        text: "User",
        align: "start",
        value: "name",
      },
      { text: "Email", value: "email" },
      { text: "Access Level", value: "alevel" },
      { text: "Actions", value: "action" },
    ],
    users: [],
    usersAc: [],
  }),
  methods: {
    getSelectedValue() {
      if (this.status == "ban") {
        this.tableTitle = "Deactivated Accounts";
      } else if (this.status == "unban") {
        this.tableTitle = "Active Accounts";
      } else {
        this.tableTitle = "All User Accounts";
      }
      axios
        .postDataWithToken(
          "/auth/get-specific-users",
          { filter: this.status },
          this.getAccessToken
        )
        .then((response) => {
          this.usersAc = response;
        });
    },
    banUser(user) {
      const reason = this.$refs["user_" + user.id].lazyValue;

      if (reason != undefined) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/ban-user",
            { user: user, reason: reason },
            this.getAccessToken
          )
          .then((response) => {
            this.$store.commit("setLoader", false);
            this.tableTitle = "Deactivated Accounts";
            this.status = { text: "Deactivated User Accounts", value: "ban" };
            this.usersAc = response;
          });
      } else {
        alert("provide reason for account deactivation!");
      }
    },
    unbanUser(user) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/unban-user",
          { user: user },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.tableTitle = "Active Accounts";
          (this.status = { text: "Active User Accounts", value: "unban" }),
            (this.usersAc = response);
        });
    },
    grantAccessLevel() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/grant-access-level",
          { user: this.selectedUser, alevel: this.selectedAlevel },
          this.getAccessToken
        )
        .then((usersAc) => {
          this.$store.commit("setLoader", false);
          this.snackbarText = "Access Level Granted Successfully!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
          this.usersAc = usersAc;
        });
    },
    linkParentToStudent() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/link-parent-to-student",
          { userId: this.selectedUser.id, sid: this.selectedStudent },
          this.getAccessToken
        )
        .then((usersAc) => {
          this.$store.commit("setLoader", false);

          this.snackbarText = "Parent Successfully Linked to Student!";
          this.snackbarColor = "success";
          this.usersAc = usersAc;

          this.dialog = false;
          this.snackbarModel = true;
        });
    },

    getSelectedUser() {
      const userId = this.selectedUserId;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-user-by-id",
          { userId },
          this.getAccessToken
        )
        .then((user) => {
          this.selectedUser = null;
          this.$store.commit("setLoader", false);
          this.selectedUser = user;
        });
    },
    searchUserFromEntireDatabase() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-user-by-email",
          { userEmail: this.searchUserEmail },
          this.getAccessToken
        )
        .then((user) => {
          this.selectedUser = null;
          this.$store.commit("setLoader", false);
          this.selectedUser = user;
        });
    },
    closeDialog() {
      this.dialog = false;
      this.inviteUser = false;
    },
    openDailogInvite() {
      this.dialog = true;
      this.inviteUser = true;
    },
  },
};
</script>

<style></style>
